module.exports = __webpack_public_path__ + "static/media/log-out.7c375991.svg";